import Form from '@/views/Configuracao/Form'

const routes = [
    {
        meta: {auth: true},
        path: '/configuracao',
        name: 'configuracao',
        component: Form
    }
]
export default routes
